import { useStore } from 'features/ListBuilder/infra/react/ListBuilderStore/useStore'

export const useSelectedList = () =>
  useStore(store => store.selectList.state)
